<template>
  <div>
    <div id="container-table">
      <ts-loading-banner :loading="student_search">
        <table class="table table-hover ui-table">
          <thead>
						<tr>
              <th>{{ $t('invoice.cardNumber') }}</th>
              <th>{{ $t('invoice.studentName') }}</th>
              <th style="width:7%">{{ $t('invoice.sex') }}</th>
              <th class="ts-text-center">{{ $t('invoice.batch') }}</th>
              <th>{{ $t('invoice.subProgram') }}</th>
            </tr>
            <tr>
              <th colspan="6">
                <input
                  v-model.trim="searchValue"
                  type="text"
                  class="form-control"
                  :class="{ loading: student_search }"
                  :placeholder="$t('invoice.searchStudent')"
                />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(student, index) in student_profile_list"
                :key="index"
                @dblclick="selectStudent(student, index)"
            >
              <td
                class="ts-whitespace-no-wrap"
                  :class="{ 'selected-class': index == selectedIndex }"
              >
                {{ student.card_number }}
              </td>
              <td
                class="ts-whitespace-no-wrap"
                  :class="{ 'selected-class': index == selectedIndex }"
              >
                {{ student.full_name_en }}
              </td>
              <td
                class="ts-whitespace-no-wrap"
                  :class="{ 'selected-class': index == selectedIndex }"
              >
                {{ student.gender }}
              </td>
              <td
                class="ts-whitespace-no-wrap ts-text-center"
                  :class="{ 'selected-class': index == selectedIndex }"
              >
                {{ student.promotion }}
              </td>
              <td
                class="ts-whitespace-no-wrap"
                  :class="{ 'selected-class': index == selectedIndex }"
              >
                {{ student.acps_name_foreign }}
              </td>
            </tr>
          </tbody>
        </table>
      </ts-loading-banner>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'preInvoiceList',
	props: ['value', 'validate'],
  data() {
    return {
			model: {},
			academic: {},
      student_profile_list: [],
			student_search: false,
      searchValue: '',
			selectedIndex: null
    }
  },
  created() {
    this.academic = this.value
  },
  methods: {
    ...mapActions('officailReceiptModule', ['onGetStudentProfile']),
    selectStudent(student, index) {
      this.selectedIndex = index
      this.academic.student_name = student.full_name_en
      this.academic.main_program = student.acp_name_foreign
      this.academic.sub_program = student.acp_name_foreign
      this.academic.level_id = student.level_id ? student.level_id.split(',').map(Number) : null
      this.academic.student_id = student.student_id 
      this.academic.acp_id = student.acp_id
      this.academic.acps_id = student.acps_id
      this.academic.grade_id = null
      this.academic.year = null
      this.academic.semester = null
      this.$emit('student-info', student)
    },
    searchStudent(params) {
      this.student_search = true
      this.student_profile_list = []
      this.onGetStudentProfile(params)
        .then(response => {
          this.student_profile_list = response.data.data
        })
        .finally(() => {
          this.student_search = false
        })
    }
  },
  watch: {
    searchValue: debounce(function(value) {
      if (value) {
        this.searchStudent({
          search: value,
          filter: {
            ac_status_id: '1,3'
          },
          page: -1
        })
      }
    }, 500),
  }
}
</script>

<style lang="css" scoped>
#container-table {
  max-height: 35vh;
	height: 30vh;
  overflow: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  white-space: nowrap;
}

.table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  /* z-index: 999; */
  padding: 5px 15px;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
  cursor: pointer;
  font-size: 12px !important;
}
</style>
